/**
 * Sections du questionnaire ou une question personnalisee peut se ranger.
 *
 * `Question.step` est l'index dans cette liste, `-1` valant « pas encore
 * rangee » (valeur par defaut du formulaire d'administration). La liste suit
 * l'ordre des sections du parcours, `SurveyForm.vue` faisant foi - les deux
 * doivent rester en phase.
 *
 * Elle contenait encore « Suivi de Questionnaire », etape repliee dans la
 * presentation: toutes les sections suivantes etaient decalees d'un cran, et
 * une question rangee dans « Activite » s'annoncait sous « Emploi » dans
 * l'administration.
 */
export const QUESTION_SECTIONS = [
  { id: 'presentation', name: 'Présentation' },
  { id: 'signaletique', name: "Signalétique de L'Entreprise" },
  { id: 'activite', name: 'Activité' },
  { id: 'emploi', name: 'Emploi' },
  { id: 'autre', name: 'Autre' },
  { id: 'fiche', name: 'Fiche Signalétique' },
];

export const UNASSIGNED_SECTION = 'Non assignée';

/**
 * La section qui recueille les questions visibles restees sans rangement.
 * « Non assignee » est la valeur par defaut du formulaire d'administration:
 * une question creee visible sans y toucher n'apparaissait alors dans aucune
 * section du questionnaire, alors que l'ecran d'administration l'annoncait
 * bien visible.
 */
export const FALLBACK_SECTION_ID = 'autre';

/** @returns {string} le libelle de la section, ou « Non assignée ». */
export function sectionName(step) {
  return QUESTION_SECTIONS[step]?.name ?? UNASSIGNED_SECTION;
}

/** @returns {number} l'index de section d'une section du parcours, ou -1. */
export function stepOfSection(sectionId) {
  return QUESTION_SECTIONS.findIndex((section) => section.id === sectionId);
}

/** @returns {string[]} les libelles seuls, pour les listes deroulantes. */
export const QUESTION_SECTION_NAMES = QUESTION_SECTIONS.map((s) => s.name);

export default QUESTION_SECTIONS;
